import { BUSCAR_ULTIMOS_HISTORICOS_ITINERARIO, LIMPAR_ULTIMOS_HISTORICOS_ITINERARIO } from '../../actions/types'

const initialState = undefined

export default function reducerUltimosHistoricosItinerario (state = [], action = initialState) {
  switch (action.type) {
    case BUSCAR_ULTIMOS_HISTORICOS_ITINERARIO: {
      const historicos = action.payload.data;
      if (historicos) {
        return  historicos;
      }
      return []
    }

    case LIMPAR_ULTIMOS_HISTORICOS_ITINERARIO:
        return [];
    
    default: {
      return state
    }
  }
}
